import { AssetTypeCode } from 'types/models/asset-type';
import SamplePoint from 'types/models/samplePoint';
import { WeatherSamplePoint } from 'types/models/weather-station';
import { getAssociatedSamplePointsFromWeatherStationController } from 'utils/associated-sample-points/get-original-sample-point-ids-from-merged-sample-point';

const enrichAttributesFromController = (sp: WeatherSamplePoint, controller: SamplePoint): SamplePoint => ({
  ...sp,
  isConfigured: controller.isConfigured,
  siteId: controller.siteId,
  siteName: controller.siteName,
  siteTimezoneCode: controller.siteTimezoneCode,
  location: controller.location,
  device: controller.device
});

export const findNestedWeatherSensors = (
  topLevelSamplePoints: SamplePoint[],
  compareField?: keyof SamplePoint,
  compareValue?: any
): SamplePoint[] => {
  const nestedWeatherSensors: SamplePoint[] = [];
  const weatherStations: SamplePoint[] = topLevelSamplePoints
    .filter(sp => sp.assetTypeId === AssetTypeCode.WEATHER_STATION_CONTROLLER);
  for (const ws of weatherStations) {
    const associatedSPs = getAssociatedSamplePointsFromWeatherStationController(ws);

    if (compareField) {
      const matches: WeatherSamplePoint[] = associatedSPs.filter(sp => sp[compareField] === compareValue);
      nestedWeatherSensors.push(...matches.map(sp => enrichAttributesFromController(sp, ws)));
    } else {
      nestedWeatherSensors.push(...associatedSPs.map(sp => enrichAttributesFromController(sp, ws)));
    }
  }

  return nestedWeatherSensors;
};